import naturalCompare from "../../../functions/naturalCompare"

const sortAlphabetical = (attributes) => attributes.sort(function(a, b) {
    return naturalCompare(a, b)
    // return b > a ? -1 : b < a ? 1 : 0
})

export default sortAlphabetical